/**

class ResultadosAutomaticos {

  id: number;
  enunciado: string;

  alternativas: [
    {
      id: number;
      enunciado: string;

      perguntasCorrelacionadas: [
        {
          id: number;
          enunciado: string;
          alternativas: [
            {
              id: number;
              enunciado: string;
              correlacao: number;
            }
          ]
        }
      ]
    }
  ],

}

*/

function toAlternativaChild(alternativa) {
  const { enunciado } = alternativa;

  return {
    value: Math.abs(alternativa.correlacao),
    correlacao: alternativa.correlacao,
    name: enunciado,
    group: false,
    path: enunciado,
    children: [],
  };
}

function toAlternativaChildren(alternativas) {
  const children = alternativas.map((alternativa) => toAlternativaChild(alternativa));

  return children;
}

function toPerguntaChild(size, perguntaCorrelacionada) {
  const { enunciado, alternativas } = perguntaCorrelacionada;

  return {
    value: size,
    name: enunciado,
    path: enunciado,
    group: true,
    children: toAlternativaChildren(alternativas),
  };
}

function toPerguntaChildren(perguntasCorrelacionadas) {
  const children = perguntasCorrelacionadas.map((pergunta) => {
    const perguntSize = 100 / perguntasCorrelacionadas.length;
    return toPerguntaChild(perguntSize, pergunta);
  });

  return children;
}

function toEchartData(resultados) {
  const alternativasNumber = resultados.alternativas.length;
  const sliceSize = 100 / alternativasNumber;

  const nodes = resultados.alternativas.map((alternativa) => {
    const { perguntasCorrelacionadas } = alternativa;
    const node = {
      value: sliceSize,
      name: alternativa.enunciado,
      group: false,
      path: alternativa.enunciado,
      children: toPerguntaChildren(perguntasCorrelacionadas),
    };

    return node;
  });

  // Lista ordenada (em ordem de primeira aparição) das perguntas correlacionadas únicas —
  // essa é a "ordem canônica" que indexa as cores no `option.color` e em `option.legend.data`,
  // usada pelo pipeline de color picker (índice numérico do item clicado).
  const seen = new Set();
  const legends = [];
  nodes.forEach((altPrincipal) => {
    if (!Array.isArray(altPrincipal.children)) return;
    altPrincipal.children.forEach((pergunta) => {
      if (pergunta && !seen.has(pergunta.path)) {
        seen.add(pergunta.path);
        legends.push(pergunta.path);
      }
    });
  });

  const result = {
    seriesData: nodes,
    legends,
  };

  return result;
}

export default toEchartData;
